import React, { useState } from 'react';
import { Home } from './pages/Home';
import { Leaderboards } from './pages/Leaderboards';
import { TestFlow } from './pages/TestFlow';
import { ContactGate } from './pages/ContactGate';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { ViewState } from './types';
import { getAdminSession } from './utils/auth';
export function App() {
  const [view, setView] = useState<ViewState>('home');
  const [playerName, setPlayerName] = useState('');
  const navigateTo = (newView: ViewState) => {
    window.scrollTo(0, 0);
    setView(newView);
  };
  return <div className="min-h-screen bg-zinc-950 text-white font-sans selection:bg-orange-500 selection:text-white" data-id="element-0">
      {view === 'home' && <Home onStart={() => navigateTo('test')} onLeaderboards={() => navigateTo('leaderboards')} onAdmin={() => navigateTo(getAdminSession() ? 'admin' : 'admin-login')} data-id="element-1" />}

      {view === 'test' && <TestFlow onComplete={() => navigateTo('leaderboards')} onHome={() => navigateTo('home')} onViewLeaderboard={(name: string) => {
      setPlayerName(name);
      navigateTo('contact-gate');
    }} data-id="element-2" />}

      {view === 'contact-gate' && <ContactGate playerName={playerName} onUnlock={(_email, _phone) => navigateTo('leaderboards')} onBack={() => navigateTo('test')} data-id="element-3" />}

      {view === 'leaderboards' && <Leaderboards onHome={() => navigateTo('home')} data-id="element-4" />}

      {view === 'admin-login' && <AdminLogin onSuccess={() => navigateTo('admin')} onBack={() => navigateTo('home')} data-id="element-5" />}

      {view === 'admin' && <AdminDashboard onLogout={() => navigateTo('home')} data-id="element-6" />}
    </div>;
}